import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export const actionTypes = {
  Logout: '[Logout] Action',
  SetToken: '[SetToken] Action',
  SetAkdemicToken: '[SetAkdemicToken] Action'
}

const initialAuthState = {
  authToken: undefined,
  akdemicToken: undefined
}

export const reducer = persistReducer(
  {
    storage,
    key: 'demo1-auth',
    whitelist: ['authToken','akdemicToken']
  },
  (state = initialAuthState, action) => {
    switch (action.type) {
      case actionTypes.Logout: {
        window.localStorage.removeItem('token')
        window.localStorage.removeItem('akdemicToken')
        return initialAuthState
      }

      case actionTypes.SetToken: {
        const { authToken } = action.payload
        window.localStorage.setItem('token', authToken)

        return {
          authToken
        }
      }

      case actionTypes.SetAkdemicToken: {
        const { akdemicToken } = action.payload
        window.localStorage.setItem('akdemicToken', akdemicToken)

        return {
          akdemicToken
        }
      }

      default:
        return state
    }
  }
)

export const actions = {
  setToken: authToken => ({ type: actionTypes.SetToken, payload: { authToken } }),
  setAkdemicToken: akdemicToken => ({ type: actionTypes.SetAkdemicToken, payload: { akdemicToken } }),
  logout: () => ({ type: actionTypes.Logout })
}
